<template>
  <div class="loadingPage">
    <div class="inner">
      <van-loading type="spinner" color="#1989fa" size="24" vertical>
        正在为您跳转页面...
      </van-loading>
    </div>
  </div>
</template>

<script>
export default {
  name: "loadingPage",
  data() {
    return {
      role: localStorage.getItem("role"),
    }
  },
  mounted() {
    setTimeout(() => {
      if (!this.role) {
        this.$router.replace({
          path: "/login"
        });
      } else {
        let roleTrans = {
          1: "/dispatch/business", // 调度
          2: "/accountant/business",  // 会计
          3: "/workOrder/order", // 安装
          4: "/audit/work",// 审核
          5: "/workOrder/order",//安装管理
          6: "/generateWorkOrder",//安装管理
        }
        this.$router.replace({
          path: roleTrans[this.role]
        });
      }
    }, 2000)
  }
}
</script>

<style lang="less">
.loadingPage {
  width: 100vw;
  height: 100vh;
  position: relative;

  .inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
</style>